// client/src/pages/Login.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/dashboard');
    } catch (err) {
      setError('Invalid email or password');
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.box}>
        {/* 🟢 Renter Logo */}
        <img
          src="/logo.png"
          alt="Renter Logo"
          style={styles.logo}
        />
        <h1 style={styles.title}>Renter Admin</h1>
        <p style={styles.subtitle}>Sign in to access the admin dashboard</p>

        <form onSubmit={handleLogin} style={styles.form}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            required
            onChange={(e) => setEmail(e.target.value)}
            style={styles.input}
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            required
            onChange={(e) => setPassword(e.target.value)}
            style={styles.input}
          />
          {error && <p style={styles.error}>{error}</p>}

          <div style={styles.actions}>
            <a href="#" onClick={(e) => e.preventDefault()} style={styles.link}>
              Forgot password?
            </a>
            <button type="submit" style={styles.button}>
              Login
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

const styles = {
  container: {
    backgroundColor: '#f6fff8',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: 'system-ui, sans-serif',
  },
  box: {
    backgroundColor: '#ffffff',
    border: '1px solid #ddd',
    borderRadius: '12px',
    padding: '2rem',
    boxShadow: '0 6px 16px rgba(0,0,0,0.08)',
    width: '100%',
    maxWidth: '420px',
    textAlign: 'center',
    transition: 'all 0.3s ease-in-out',
  },
  logo: {
    width: '100px',           // 👈 Increased size for a more prominent logo
    height: '100px',
    marginBottom: '1.2rem',
    borderRadius: '16px',
  },
  title: {
    fontSize: '2rem',
    color: '#2e7d32',
    marginBottom: '0.4rem',
    fontWeight: '600',
  },
  subtitle: {
    fontSize: '1rem',
    color: '#555',
    marginBottom: '1.8rem',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  input: {
    padding: '0.8rem',
    borderRadius: '8px',
    border: '1px solid #ccc',
    fontSize: '1rem',
    transition: 'border-color 0.2s',
  },
  actions: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '0.5rem',
  },
  link: {
    fontSize: '0.9rem',
    color: '#388e3c',
    textDecoration: 'none',
    transition: 'color 0.3s',
    cursor: 'pointer',
  },
  button: {
    backgroundColor: '#4caf50',
    color: '#fff',
    border: 'none',
    padding: '0.75rem 1.2rem',
    fontSize: '1rem',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
  },
  error: {
    color: 'red',
    fontSize: '0.9rem',
  },
};
